<div class="page-inner-body portlet light">
  <div class="portlet-body">
    <!-- Top Action Bar -->
    <div class="top-action-bar">
      <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
        <div class="d-flex flex-column align-items-start">
          <div class="d-flex align-items-center gap-2">
            <span class="page-title">{{ 'gallerySharableProducts.totalArtworks' | transloco }}</span>
            @if (galleryProducts.length > 0) {
              <span class="count-badge">
                {{ galleryProducts.length }}
              </span>
            }
          </div>
          <div class="page-subtitle mt-1">
            {{ 'gallerySharableProducts.pageSubtitle' | transloco }}
          </div>
        </div>
        <div class="d-flex align-items-center gap-2">
          <p-button type="button" [label]="'gallerySharableProducts.createNewProduct' | transloco" class="ms-2" [outlined]="true"
            (click)="createNewProduct()">
          </p-button>
        </div>
      </div>
    </div>

    <!-- Skeleton Loader -->
    @if (isLoading) {
      <div class="row my-2">
        @for (placeholder of [1,2]; track placeholder) {
          <div class="col-6 mt-3">
            <div class="skeleton-card">
              <div class="skeleton-image"></div>
              <div class="skeleton-details">
                <div class="skeleton-text skeleton-title"></div>
                <div class="skeleton-text skeleton-line"></div>
                <div class="skeleton-text skeleton-line short"></div>
                <div class="skeleton-text skeleton-line"></div>
              </div>
            </div>
          </div>
        }
        <div class="col-12 text-center text-muted small mt-3">
          <i class="pi pi-spin pi-spinner me-2"></i> {{ 'gallerySharableProducts.loadingArtworks' | transloco }}
        </div>
      </div>
    }

    <div class="row mt-4 my-2">
      <div class="col-6">
        <p-table #dt [value]="galleryProducts" dataKey="Id" [rowHover]="true"
          styleClass="p-datatable-gridlines p-datatable-striped" [globalFilterFields]="['Name', 'SerialNumber']"
          [paginator]="galleryProducts.length > 10" [rows]="10" [reorderableColumns]="true"
          [resizableColumns]="false">
          <ng-template pTemplate="caption">
            {{ 'gallerySharableProducts.availableArtworks' | transloco }}
            @if (isCurrentInventoryLoaded) {
              <span>
                ({{ galleryProducts.length }})
              </span>
            }
            <div class="table-header mt-2">
              <div class="row">
                <div class="col-12 text-right">
                  <div
                    class="searchbox rounded-3 w-100 position-relative d-flex align-items-center flex-row-reverse border bg-white">
                    <button type="button"
                      class="bg-transparent border-0 py-2 px-3 d-flex align-items-center justify-content-center position-absolute">
                      <i class="text-muted fa fa-search icon-block icon-block--search-blue is--small"></i>
                    </button>
                    <input type="text"
                      class="form-control form-control-sm bg-transparent w-100 h-100 shadow-none border-0 px-3 py-2"
                        (input)="
                          dt.filterGlobal($any($event.target).value, 'contains')
                        " [placeholder]="'gallerySharableProducts.searchArtworksByName' | transloco" />
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
            <ng-template pTemplate="body" let-rowData>
              <tr class="cursor-pointer border-start border-end border-bottom">
                <td class="px-2">
                  <div class="d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-start" (click)="showProductDetail(rowData)">
                      <img [src]="
                          rowData.Product.ProductImgUrl != null
                            ? rowData.Product.ProductImgUrl
                            : 'assets/images/No-Image.png'
                        " [width]="40" [height]="40" class="me-2" style="object-fit: contain; background:#f6f7f9; border-radius:6px;" />
                        <div class="d-flex flex-column align-items-start">
                          <a href="javascript:void(0);" class="text-uppercase">
                            {{ rowData.Product.SerialNumber }} -
                            {{ rowData?.Product?.Name }}
                          </a>
                          <div class="text-secondary small">
                            {{rowData.Product.ArtistShortDescription}}
                          </div>
                        </div>
                      </div>
                      <ng-container>
                        <i (click)="selectInventory(rowData)" class="fa fa-arrow-right ms-3"
                        [title]="'gallerySharableProducts.moveToSelected' | transloco"></i>
                      </ng-container>
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td [attr.colspan]="1">
                    <div class="text-center">{{ 'gallerySharableProducts.noAvailableArtworks' | transloco }}</div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>

          <div class="col-6">
            <p-table #selectedDt [value]="selectedGalleryProductsInventory" dataKey="Id" [rowHover]="true"
              styleClass="p-datatable-gridlines p-datatable-striped" [globalFilterFields]="['Name', 'SerialNumber']"
              [paginator]="false" [rows]="10" [reorderableColumns]="true" [resizableColumns]="false">
              <ng-template pTemplate="caption">
                <div class="d-flex justify-content-between align-items-center">
                  <div>{{ 'gallerySharableProducts.selectedArtworks' | transloco }}</div>
                  <div class="d-flex align-items-center">
                    @if (selectedGalleryProductsInventory.length > 0) {
                      <button pButton type="button"
                        class="p-button-outlined p-button-sm ms-2" (click)="onShowPageConfigrationDailog()">
                        <i class="fa fa-link me-2"></i> {{ 'gallerySharableProducts.generateLink' | transloco }}
                        <span class="ms-2 text-outlined">({{ selectedGalleryProductsInventory.length }})</span>
                      </button>
                    }
                  </div>
                </div>
                <div class="table-header mt-2">
                  <div class="row">
                    <div class="col-12 text-right">
                      <div
                        class="searchbox rounded-3 w-100 position-relative d-flex align-items-center flex-row-reverse border bg-white">
                        <button type="button"
                          class="bg-transparent border-0 py-2 px-3 d-flex align-items-center justify-content-center position-absolute">
                          <i class="text-muted fa fa-search icon-block icon-block--search-blue is--small"></i>
                        </button>
                        <input type="text"
                          class="form-control form-control-sm bg-transparent w-100 h-100 shadow-none border-0 px-3 py-2"
                        (input)="
                          selectedDt.filterGlobal(
                            $any($event.target).value,
                            'contains'
                          )
                        " [placeholder]="'gallerySharableProducts.searchArtworksByName' | transloco" />
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <ng-template pTemplate="body" let-selectedInventory>
                  <tr class="cursor-pointer border-start border-end border-bottom">
                    <td class="px-2">
                      <div class="d-flex align-items-start" (click)="showProductDetail(selectedInventory)">
                    <img [src]="
                        selectedInventory.Product.ProductImgUrl != null
                          ? selectedInventory.Product.ProductImgUrl
                          : 'assets/images/No-Image.png'
                      " [width]="40" [height]="40" class="me-2" style="object-fit: contain; background:#f6f7f9; border-radius:6px;" />
                          <div class="d-flex flex-column align-items-start">
                            <a href="javascript:void(0);" class="text-uppercase">{{ selectedInventory.Product.SerialNumber }}
                              -
                            {{ selectedInventory.Product.Name }}</a>
                            <div class="text-secondary small">
                              {{selectedInventory.Product.ArtistShortDescription}}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td>
                        <ng-container>
                          <i class="fa fa-arrow-left" (click)="moveToCurrentInventory(selectedInventory)"
                          [title]="'gallerySharableProducts.returnToAvailableList' | transloco"></i>
                        </ng-container>
                      </td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage">
                    <tr>
                      <td [attr.colspan]="2">
                        <div class="text-center">{{ 'gallerySharableProducts.noSelectedArtworks' | transloco }}</div>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
          </div>
        </div>

        @if (isProductShareDailogVisible) {
          <product-share [isProductShareDailogVisible]="isProductShareDailogVisible" [galleryId]="galleryId"
          [linkid]="generatedLinkId" (onCloseDailog)="onCloseProductShareDailog($event)"></product-share>
        }

        <p-dialog [header]="'gallerySharableProducts.shareablePageConfigurations' | transloco" [(visible)]="isPageConfigrationDailogVisible" [modal]="true"
          [style]="{ width: '450px' }" (onHide)="onClosePageConfigrationsDailog()">
          <div class="text-muted mt-2">
            <i class="fa fa-info-circle me-1"></i>{{ 'gallerySharableProducts.configurationsInfo' | transloco }}
          </div>
          <div class="d-flex align-items-center ms-3 mt-2">
            <p-checkbox [(ngModel)]="isShowProfile" [binary]="true" [label]="'gallerySharableProducts.showProfile' | transloco" name="isShowProfile"
              (onChange)="onShowProfileChange($event)" />
            </div>
            <hr />
            <label class="ms-3 fw-bold">{{ 'gallerySharableProducts.alignmentConfigurations' | transloco }}</label>
            <div class="d-flex align-items-center ms-3 mt-2">
              <p-radioButton name="Show 4 Columns" [value]="3" [(ngModel)]="selectedColumnCount" inputId="showFourColumns"
                (onClick)="onColumnCountChange(selectedColumnCount)" />
                <label for="showFourColumns" class="ms-2"> {{ 'gallerySharableProducts.show3Columns' | transloco }} </label>
              </div>
              <div class="d-flex align-items-center ms-3 mt-2">
                <p-radioButton name="Show 5 Columns" [value]="4" [(ngModel)]="selectedColumnCount" inputId="showFiveColumns"
                  (onClick)="onColumnCountChange(selectedColumnCount)" />
                  <label for="showFiveColumns" class="ms-2"> {{ 'gallerySharableProducts.show4Columns' | transloco }} </label>
                </div>
                <div class="d-flex align-items-center ms-3 mt-2">
                  <p-radioButton name="Show 6 Columns" [value]="6" [(ngModel)]="selectedColumnCount" inputId="showSixColumns"
                    (onClick)="onColumnCountChange(selectedColumnCount)" />
                    <label for="showSixColumns" class="ms-2"> {{ 'gallerySharableProducts.show6Columns' | transloco }} </label>
                  </div>
                  <div class="float-end mt-2">
                    <button pButton class="p-button-outlined" [label]="'gallerySharableProducts.getLink' | transloco" (click)="generateLink()"></button>
                  </div>
                </p-dialog>